import React, {Component, Fragment} from 'react';
import {PGService} from '../../Remote/PowerGym';
import {showLoadingBar, hideLoadingBar} from "../../Redux/actions/loading";
import {connect} from 'react-redux';
import {showSnackbar} from "../../Redux/actions/snackbar";
import {Formatters} from "../../Utils/Formatters";
import {withNamespaces} from 'react-i18next';

class Routine extends Component {

    constructor(props) {
        super(props);

        this.state = {
            routine: ""
        };
    }

    componentDidMount() {
        this.loadRoutine();
    }

    /**
     * Performs the API call to get players from server. Also, set loading true to show the spinner component
     */
    loadRoutine = () => {

        this.props.showLoadingBar();

        PGService.routine().then(response => {

            let routine;

            if (typeof response.data.routine !== 'undefined') {
                routine = response.data.routine;
            }

            if (!routine || !routine.content) {
                routine = {
                    content: this.props.t("No routines. Ask your manager to add a new one.")
                }
            }

            this.setState({routine});

            this.props.hideLoadingBar();
        })
            .catch((e) => console.log(e));
    };

    render() {
        const {t} = this.props;

        return (
            <Fragment>
                <h2>{t("My Routine")}</h2>
                {this.state.routine.created_at &&
                <Fragment>
                    <ul>
                        <li>{t("Created at")}: {Formatters.formatDate(this.state.routine.created_at)}</li>
                        <li>{t("Last updated at")}: {Formatters.formatDate(this.state.routine.created_at)}</li>
                    </ul>
                </Fragment>}

                <hr/>

                {this.state.routine.content &&
                <div className="rutine" dangerouslySetInnerHTML={{__html: this.state.routine.content}}/>}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(Routine));
